import React from "react";
import styles from "./dashboard.module.scss";
//import Carousel from "react-elastic-carousel";
import Product from "../../components/product/Product";
import Title from "../../components/title/Title";

const StrategicAcctDashboard = (props) => {

    const { data } = props;

    const showStrategicActDetail = (item) => {
        console.log("On Click of strategic tile--item",item);
        props.setStrategicAct(item)//Need to add accounts in Redux store
        props.history.push("/dashboard/strategicaccountsdetail");//strategicaccountsdetail  //groupdetail
    }

    return (
        <div className={`${styles.strategicActContWidth}`}>
            <div className={`${styles.strategicProductsContainer}`}>
                <div className={styles.productBox}>
                    <Title value="Strategic Accounts" />
                    <Product
                        product={data.strategicAccounts}
                        {...props}
                        type="strategicaccount"
                        showDetail={() => showStrategicActDetail(data.strategicAccounts)} />
                </div>
            </div>
        </div>
    )

}
export default StrategicAcctDashboard;
//instead of data.group , write data.accounts in 2 places in <product>